




















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import AutomatedInsights, { AutomatedInsightObj } from './AutomatedInsights.vue'
import SurveyQuestion from './SurveyQuestion.vue'
import { SliceOption } from './Utilities/ChartUtilities'

import SurveyFindings from './SurveyFindings.vue'
import ResponseManagement from '@/components/Survey/ResponseManagement/ResponseManagement.vue'
import store from '@/store'
import { QuestionType, SliceType } from '@shared/types/database'
import A from '@/utilities/alpha'
import { Select, Button } from '@alpha/ink'
import router, { sharedViewRouteName } from '@/router'

import DropdownButton from '@/components/DropdownButton.vue'

@Component({
  components: {
    SurveyQuestion,
    Select,
    Button,
    AutomatedInsights,
    SurveyFindings,
    DropdownButton,
    ResponseManagement
  }
})
export default class LiveCharts extends Vue {
  @Prop({ default: false }) readonly isAdminLiveCharts!: boolean
  @Prop({ default: false }) showManageResponses!: boolean

  selectedSlice: SliceOption = this.sliceOptions[0]

  get newTestExperienceEnabled () {
    return store.getters.feature.hasFeature('newTestExperience')
  }

  get questions () {
    return store.getters.survey.questionsWithResponses
  }

  get mainInsights ():AutomatedInsightObj[] {
    return store.getters.survey.insights
      .filter(i => {
        const config = store.getters.surveyConfiguration.questionConfigById(i.questionId)
        const showInsight = !this.publicView || (this.publicView && config.visible)
        return i.type === 'Main' && showInsight
      })
      .map(i => ({
        ...i,
        question: store.getters.survey.questionById(i.questionId)!,
        config: store.getters.surveyConfiguration.questionConfigById(i.questionId)
      }))
      .sort((aInsight, bInsight) => {
        return aInsight.question.displayOrder! - bInsight.question.displayOrder!
      })
  }

  get findings () {
    return store.state.surveyConfiguration.findings
  }

  get publicView () {
    return this.$route.name === sharedViewRouteName
  }

  get showFindings () {
    return (!this.publicView && this.questions.length) || this.findings?.length
  }

  navToRespondentManagement () {
    this.$router.push({
      name: 'respondents'
    })
  }

  get sliceOptions (): SliceOption[] {
    const options = Object.values(SliceType).map(sliceType => {
      return { label: sliceType.toString(), value: sliceType.toString() }
    })

    const validQuestionTypes = [
      QuestionType.SingleSelect,
      QuestionType.MultiSelect,
      QuestionType.Rate,
      QuestionType.RateOnly
    ]

    this.questions.forEach(question => {
      const isVisible = question.displayOrder
      if (validQuestionTypes.includes(question.type as QuestionType) && isVisible) {
        options.push({ label: `Q${question.displayOrder}. ${A.stripHTML(question.configuration?.title || question.text)}`, value: question.id })
      }
    })

    return options
  }

  globalSliceTypeSelected (selectedOption: SliceOption) {
    this.selectedSlice = selectedOption
    this.showQuestionAndSlice(this.questions.filter(question => question.displayOrder)[0].id)
  }

  mounted () {
    this.readQueryParamsForInitialQuestion(this.$route)
  }

  scrollToInsight (insight: AutomatedInsightObj) {
    this.showQuestionAndSlice(insight.questionId, insight.questionId)
  }

  @Watch('$route', { deep: true })
  readQueryParamsForInitialQuestion (newRoute: typeof router.currentRoute, oldRoute?: typeof router.currentRoute) {
    const { question, slice } = newRoute.query
    if (oldRoute) {
      const { question: oldQuestion, slice: oldSlice } = oldRoute.query
      if (oldQuestion === question && oldSlice === slice) return
    }
    if (!question) return
    this.showQuestionAndSlice(question as string, slice as string)
  }

  showQuestionAndSlice (questionId: string, slice?: string) {
    const targetQuestion = (this.$refs[questionId] as SurveyQuestion[])[0]
    const selectedSlice = this.sliceOptions.find(option => {
      return option.value === slice
    })
    if (targetQuestion) {
      if (selectedSlice) {
        targetQuestion.sliceTypeSelected(selectedSlice)
      }
      setTimeout(() => {
        targetQuestion.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        })
      }, 200)
    }
  }
}
